import { cn } from '@/styles'
import { useCommon } from '@/core/useCommon'
import { checkPasswordRules, getStrengthColor, PASSWORD_RULES } from '@/hooks/update-password/passwordRules'

type PasswordRequirementsProps = {
  value: string
  className?: string
}

// 密碼規則面板: 滿足的規則打勾，數量進度與百分比同步，強度條依百分比變色，全部滿足時百分比變綠色
export const PasswordRequirements = ({ value, className }: PasswordRequirementsProps) => {
  const { t } = useCommon()
  const rules = checkPasswordRules(value)
  const metCount = rules.filter((rule) => rule.met).length
  const percent = Math.round((metCount / PASSWORD_RULES.length) * 100)
  const isComplete = metCount === PASSWORD_RULES.length

  return (
    <div className={cn('bg-white', className)}>
      {/* 標題 & 進度 */}
      <div className="flex flex-col gap-8 px-12">
        <div className="text-14 sm:text-16 flex items-center justify-between leading-17 font-medium text-[#0D2245] capitalize sm:leading-20">
          <span>{t('old:pwdRequirements')}</span>
          <span>
            {metCount}/{PASSWORD_RULES.length}
          </span>
        </div>

        <div className="flex items-center gap-12">
          <div className="rounded-8 h-8 flex-1 overflow-hidden bg-[#BEC7DC]">
            <div className="rounded-8 h-full transition-all duration-200" style={{ width: `${percent}%`, background: getStrengthColor(percent) }} />
          </div>
          <span className={cn('text-14 sm:text-16 min-w-40 text-right leading-17 font-medium text-[#0050C8] sm:leading-20', { 'text-[#00C784]': isComplete })}>{percent}%</span>
        </div>
      </div>

      {/* 規則 */}
      <ul className="flex flex-col gap-8 px-12 pt-8 pb-12">
        {rules.map((rule) => (
          <li key={rule.key} className={cn('text-12 sm:text-14 flex items-center gap-6 leading-14 text-[#6D7693] capitalize sm:leading-17', { 'text-[#0D2245]': rule.met })}>
            <span
              className={cn('flex size-12 shrink-0 items-center justify-center rounded-full border border-[#BEC7DC] bg-white sm:size-14', {
                'border-[#00C784] bg-[#00C784]': rule.met,
              })}>
              {rule.met && <span className="mb-1 h-3 w-6 -rotate-45 border-b border-l border-white sm:h-4 sm:w-7" />}
            </span>
            {t(rule.label)}
          </li>
        ))}
      </ul>
    </div>
  )
}
